/**
 * This IIFE will contain all dom manipulation and catalog api call logic
 * for currency converter including denominator table.
 */

(function (w, d) {
    // TODO: extract currency converter logic from wu calculator
    try {
        const checkCurrencyConverter = /\/currency-converter\/.+\.html$/.test(w.location.pathname)|| /\/currency-converter-(.)*\/.+\.html$/.test(w.location.pathname)
        const hrefSplit = w.location.pathname.split('-')
        const sendToCurrency = hrefSplit[hrefSplit.length - 2] && hrefSplit[hrefSplit.length - 2].toUpperCase()   
             
        if (checkCurrencyConverter && sendToCurrency) {
            // get receiver country
            const sendToCountry = (() => {
                const currencyCodeElement = d.querySelector(`span[title=${sendToCurrency.toUpperCase()}]`)
                const countryCode = currencyCodeElement && currencyCodeElement.getAttribute('data-countrycode')
                if (countryCode) {
                    return countryCode
                } else { // TODO: remove this block once countrycode is made mandatory in wp
                    for (let code in ISO_CODES_COUNTRIES_CURRENCIES) {
                        if (ISO_CODES_COUNTRIES_CURRENCIES[code] === sendToCurrency) return code
                    }
                }
            })()
            // prepare payload
            const calcEl = d.querySelector('.calculator')
            const reqPayload = {
                currency: calcEl.getAttribute('data-currency'),
                country: calcEl.getAttribute('data-country'),
                funds_in: calcEl.getAttribute('data-fund-in'),
                fund_out_mnem: calcEl.getAttribute('data-fund-out-mnem'),
                host: calcEl.getAttribute('data-host'),
                sendAmount: '',
                sendToCurrency: ISO_CODES_COUNTRIES_CURRENCIES[sendToCountry],
                sendToCountry
            }

            const checkTopCorridorConfig = () => {
                const corridorCountries = d.getElementById('corridor_countries');
                const countriesObj = corridorCountries && corridorCountries.innerHTML && JSON.parse(corridorCountries.innerHTML);
                const receiverCountry = countriesObj && countriesObj[sendToCountry.toLowerCase()];
                if (receiverCountry) {
                    [reqPayload.funds_in, reqPayload.fund_out_mnem] = receiverCountry;
                }
                for ( let key in countriesObj ) {
                    for(let kvalue in countriesObj[key]){
                       if(countriesObj[key][kvalue] == parseInt(sessionStorage.getItem('currency-converter-amount'))){
                           sessionStorage.removeItem('currency-converter-amount');
                       }
                    }
               };

            }
            checkTopCorridorConfig()

            const denoTbl = d.getElementById('denoTblContainer')
            const sendAmtArr = denoTbl.querySelectorAll('td:nth-child(odd)') // get elements having send amounts
            const receiveAmtArr = denoTbl.querySelectorAll('td:nth-child(even)') // get elements to be populated with receive amounts
            denoTbl.classList.remove('d-none')
            let denoTblInViewChecked = false
            const denoTable = d.getElementById("denoTable");
            const spinner = d.getElementById("spinner");
            denoTable.setAttribute('hidden','');
            const callCatalogApi = () => {
                for (let i = 0; i < sendAmtArr.length; i++) {
                    spinner.removeAttribute('hidden');
                    reqPayload.sendAmount = parseInt(sendAmtArr[i].innerText).toFixed(2) // get send amount, eg 1.00 from 1 AUD
                    const priceCatalogConfig = triggerPriceCatalog(reqPayload);
                    httpRequest.post(priceCatalogConfig.url, priceCatalogConfig.reqPayload)
                        .then((response) => {
                            let {
                                receiveAmount
                            } = priceCatalogConfig.initApi(response)
                             if (receiveAmount !== 0) {
                                 receiveAmtArr[i].innerText = `${receiveAmount.toFixed(2)} ${sendToCurrency}`;
                                     if(i== (sendAmtArr.length-1)){
                                        handleDenoTableShowHide(spinner, denoTable);
                                     }
                                 }else if (receiveAmount == 0) {
                                    sendAmtArr[i].parentNode.parentNode.removeChild(sendAmtArr[i].parentNode);
                                     handleDenoTableShowHide(spinner, denoTable);
                                 }
                                else receiveAmtArr[i].parentNode.parentNode.removeChild(receiveAmtArr[i].parentNode)
                            }).catch((err) => {
                                if(i==0){
                                    denoTbl.setAttribute('hidden','');
                                    spinner.setAttribute('hidden','');
                                }
                            });
                }
            }
           
            const isDenoTblInViewport = () => {
                if (!denoTblInViewChecked) { // throttled the events
                    denoTblInViewChecked = true
                    setTimeout(() => {
                        if ((denoTbl.getBoundingClientRect().top <= w.innerHeight && denoTbl.getBoundingClientRect().bottom >= 0)) { // check is elem visible
                            callCatalogApi()
                            w.removeEventListener("scroll", isDenoTblInViewport)
                            w.removeEventListener("resize", isDenoTblInViewport)
                            w.removeEventListener("load", isDenoTblInViewport)
                        }
                        denoTblInViewChecked = false
                    }, 200)
                }
            }

            w.addEventListener("scroll", isDenoTblInViewport)
            w.addEventListener("resize", isDenoTblInViewport)
            w.addEventListener("load", isDenoTblInViewport)
        }
    } catch (err) {
        console.warn('Error in currency converter', err)
    }
})(window, document);

document.addEventListener('triggerReceiveAmountElem', () => {  
              
    if (calc.prevReceiverValue != calc.receiveAmountElem.value) {
        calc.lastTouchedInput = 'receiverAmtField';
        if (calc.initFXTimeout != null) {
            clearTimeout(calc.initFXTimeout)
        }
        let sendAmount = parseFloat(calc.receiveAmountElem.value / calc.fxToElem.innerHTML.split(" ")[0]).toFixed(2);
        calc.sendAmountElem.value  = sendAmount;                
        calc.initFXTimeout = setTimeout(() => {
            calc.initFXTimeout = null
            calc.receiverAmount = calc.receiveAmountElem.value;
            calc.initFX(calc.receiverAmount);
            calc.prevReceiverValue = calc.receiveAmountElem.value;
        }, 2000)
    }}        
);
function handleDenoTableShowHide(spinnerElement, denoTableElement) {
    spinnerElement.setAttribute('hidden','');
    denoTableElement.removeAttribute('hidden');
}